import moment from "moment";
import { callAPI } from "../config/AxiosTemplate";
import {
  CLEAR_LOAN_APPLICATION_DETAILS,
  LOAN_APPLICATION_BASIC_INFO_DETAILS,
  LOAN_APPLICATION_DETAILS,
  SAVE_APPLICATION_ID,
} from "./Constants";

import {
  API_RESPONSE_STATUS_CODES,
  API,
  DATE_FORMAT,
} from "../Utils/Constants";
import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";

export const getLoanApplicationsOnLoanPortfolioAction = (
  filterSerachObject,
  callback
) => {
  let request = {
    filter: {
      fromDate: filterSerachObject.disbursementFromDate
        ? new moment(filterSerachObject.disbursementFromDate).format(
          DATE_FORMAT
        )
        : undefined,
      category: filterSerachObject.filter.filterCategory
        ? filterSerachObject.filter.filterCategory
        : null,
      toDate: filterSerachObject.disbursementToDate
        ? new moment(filterSerachObject.disbursementToDate).format(DATE_FORMAT)
        : undefined,
      userId: filterSerachObject.userId,
      disbursementFromDate: filterSerachObject.filter.disbursementFromDate
        ? new moment(filterSerachObject.filter.disbursementFromDate).format(
          DATE_FORMAT
        )
        : undefined,
      disbursementToDate: filterSerachObject.filter.disbursementToDate
        ? new moment(filterSerachObject.filter.disbursementToDate).format(
          DATE_FORMAT
        )
        : undefined,
      provincia: filterSerachObject.filter.provincia ? filterSerachObject.filter.provincia : null
    },
    search: {
      clientId: filterSerachObject.clientId,
      applicationId: filterSerachObject.filter.searchLoanID,
      name: filterSerachObject.searchName,
      phoneNumber: filterSerachObject.searchPhoneNumber,
    },
    limit: filterSerachObject.limit ? filterSerachObject.limit : 10,
    offset: filterSerachObject.offset ? filterSerachObject.offset - 1 : 0,
  };

  let origin = window.location.hash === `#${APPLICATION_CONFIGURATIONS.path.dashboardAppresta}` ? "APPRESTA" : ""
  callAPI(
    "GetLoanApplicationsOnLoanPortfolio",
    API.getLoanApplicationsOnLoanPortfolio + "?origin=" + origin,
    "POST",
    request,
    (apiResponse) => {
      if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        callback(apiResponse.data.data);
      } else {
        callback(null);
      }
    }
  );
};

export const getClientInfoByIdAction = (id, callback) => (dispatch) => {
  callAPI(
    "getClientInfoById",
    API.getClientInfoById + id,
    "GET",
    {},
    (apiResponse) => {
      if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        dispatch({
          type: LOAN_APPLICATION_BASIC_INFO_DETAILS,
          data: apiResponse.data.data.data,
        });
        callback(apiResponse.data.data.data);
      } else {
        callback(null);
      }
    }
  );
};

export const getLoanApplicationByIdAction = (id, callback) => (dispatch) => {
  callAPI(
    "getLoanApplication",
    API.getLoanApplication + "/" + id,
    "GET",
    {},
    (apiResponse) => {
      if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        dispatch({
          type: LOAN_APPLICATION_DETAILS,
          loanApplicationDetails: apiResponse.data.data.data,
        });
        callback(apiResponse.data.data);
      } else {
        callback(null);
      }
    }
  );
};

export const getReceiptAction = (id, receiptType, callback) => (dispatch) => {
  callAPI(
    "getLoanApplication",
    API.getReceipt + "/" + id + "?type=" + receiptType,
    "GET",
    {},
    (apiResponse) => {
      if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        callback(apiResponse.data.data);
      } else {
        callback(null);
      }
    },
    false,
    true
  );
};

export const downloadLiveData = (searchFilterObject, callback) => {
  let request = { ...searchFilterObject };
  request["filter"]["disbursementFromDate"] = new moment(
    searchFilterObject.filter.disbursementFromDate
  ).format(DATE_FORMAT);
  request["filter"]["disbursementToDate"] = new moment(
    searchFilterObject.filter.disbursementToDate
  ).format(DATE_FORMAT);
  callAPI(
    "downloadLiveData",
    API.downloadLiveData,
    "POST",
    request,
    (apiResponse) => {
      if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        callback(apiResponse.data);
      } else {
        callback(apiResponse);
      }
    }
  );
};

export const generateAuditAction = (id, callback) => {
  callAPI(
    "generateAudit",
    API.generateAudit + id,
    "POST",
    {},
    (apiResponse) => {
      if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        callback(apiResponse.data.data);
      } else {
        callback(apiResponse);
      }
    }
  );
};

export const getYearDropdownListAction = (audit_type, callback) => {
  callAPI(
    "yearDropdownList",
    API.yearDropdownList + audit_type,
    "GET",
    {},
    (apiResponse) => {
      if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        callback(apiResponse.data);
      } else {
        callback(apiResponse);
      }
    }
  );
};

export function saveLoanApplicationId(loanApplicationId) {
  return {
    type: SAVE_APPLICATION_ID,
    loanApplicationId: loanApplicationId,
  };
}

/**
 * Action to clear loan application details
 */
export function clearLoanApplicationDetailsAction() {
  return {
    type: CLEAR_LOAN_APPLICATION_DETAILS,
  };
}
